/**
 * Волна B (docs/MIGRATION_ROUTER.md §5). Было: <CacheDataRoute path='/promokod-pravila'>.
 */
import { createFileRoute } from '@tanstack/react-router';
import CacheDataRoute from '../CacheDataRoute';
import PromocodeRules from '@routes/StaticPages/LegalPages/PromocodeRules';

export const Route = createFileRoute('/promokod-pravila')({
  component: () => (
    <CacheDataRoute component={PromocodeRules} path='/promokod-pravila' />
  )
});
